import React from "react";
import { EmailShareButton, WhatsappShareButton } from "react-share";
import { Modal } from "react-bootstrap";
import "font-awesome/css/font-awesome.min.css";
import WhatsappIcon from "../assets/whatsapp_icon.svg";
import EmailIcon from "../assets/email_icon.svg";

const SocialShareModal = ({
  url,
  showModal,
  onCloseModal,
  onCopyLink,
  isTextCopied,
  schoolId,
  teacherName,
  teacherMobileNumber,
}) => {
  const title = `Greenfield reference link for  ${teacherName || ""} (${
    teacherMobileNumber || ""
  }) of school - ${schoolId}`;
  return (
    <Modal
      className="share-modal-container"
      show={!!showModal}
      onHide={onCloseModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>Share</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
            <div className="mb-2" style={{fontSize: "14px", fontWeight: '500'}}>Share this link via</div>
            <div className="social-media-share-container">
              <div className="share-btn">
                <EmailShareButton
                  title="Email Share"
                  subject={title}
                  separator=""
                  body={`${url}`}
                >
                  <img className="mb-1 mr-1" src={EmailIcon} alt="icon" />
                  Email
                </EmailShareButton>
              </div>
              <div className="share-btn">
                <WhatsappShareButton url={url} content={url} title={title}>
                  <img className="mb-1 mr-1" src={WhatsappIcon} alt="icon" />
                  Whatsapp
                </WhatsappShareButton>
              </div>
          </div>
          <div className="mb-2" style={{fontSize: "14px"}}>Or copy link</div>
          <div className="copy-url-container">
            <i style={{fontSize: "14px"}} className="fa fa-link"></i>
            <input
              id="url-container"
              className="url-container"
              value={url || "Unable to generate link, please copy it manually"}
              readOnly
            ></input>
            <button
              className={`copy-btn ${isTextCopied ? "copy-btn-active" : ""}`}
              onClick={() => onCopyLink(url)}
            >
            {isTextCopied ? "Copied!" : "Copy Link"}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SocialShareModal;
